import { EventType } from '../../../constants/eventTypes';
import { ProductBuilderMachineState } from '../../../types';

type StateTransitionEvents = {
  [key in EventType]: {
    target: ProductBuilderMachineState | 'measurements.idle';
  };
};

const stateTransitionEvents: StateTransitionEvents = {
  BOTTOM_RAIL_COLOUR: {
    target: 'bottomRailColour',
  },
  BRACKET_COLOUR: {
    target: 'bracketColour',
  },
  COMPONENTS_COLOUR: {
    target: 'componentsColour',
  },
  BOTTOM_BAR_COLOUR: {
    target: 'bottomBarColour',
  },
  CELL_DESIGN: {
    target: 'cellDesign',
  },
  CHAIN_COLOUR: {
    target: 'chainColour',
  },
  CHAIN_POSITION: {
    target: 'chainPosition',
  },
  CHAIN_RELEASE: {
    target: 'chainRelease',
  },
  CHAIN_TYPE: {
    target: 'chainType',
  },
  COLOUR: {
    target: 'colour',
  },
  COLOUR_DAY: {
    target: 'colourDay',
  },
  COLOUR_NIGHT: {
    target: 'colourNight',
  },
  COMMON_VALANCE: {
    target: 'commonValance',
  },
  COMPLETE: {
    target: 'complete',
  },
  CONFIGURATION: {
    target: 'configuration',
  },
  CORD_POSITION: {
    target: 'cordPosition',
  },
  DAY_COLOUR: {
    target: 'dayColour',
  },
  DAY_FABRIC_POSITION: {
    target: 'dayFabricPosition',
  },
  DESIGNER_TAPE: {
    target: 'designerTape',
  },
  DRIVE_CONTROL: {
    target: 'driveControl',
  },
  EXTENSION_POLE: {
    target: 'extensionPole',
  },
  FITTING: {
    target: 'fitting',
  },
  HOLD_DOWN_BRACKETS: {
    target: 'holdDownBrackets',
  },
  IDLE: {
    target: 'idle',
  },
  LIFT_POSITION: {
    target: 'liftPosition',
  },
  LIGHT_GUARDS: {
    target: 'lightGuards',
  },
  TRANSPARENCY: {
    target: 'transparency'
  },
  LINING: {
    target: 'lining',
  },
  WAND_OPTION : {
    target: 'wand_option',
  },
  WAND_COLOUR : {
    target: 'wand_colour',
  },
  WAND_COLOUR_PRICE: {
    target: 'wand_colour_price',
  },
  WAND_COLOUR_VARIANT_ID: {
    target: 'wand_colour_variant_id',
  },
  TRACK_COLOUR_VARIANT_ID: {
    target: 'track_colour_variant_id',
  },
  TRACK_COLOUR_PRICE: {
    target: 'track_colour_price',
  },
  LINING_COLOUR_VARIANT_ID: {
    target: 'lining_colour_variant_id',
  },
  LINING_COLOUR_PRICE: {
    target: 'lining_colour_price',
  },
  LININGCOLOUR: {
    target: 'liningColour'
  },
  LINING_STYLE: {
    target: 'liningStyle',
  },
  MATERIAL_TYPE: {
    target: 'materialType',
  },
  MATERIAL_TYPE_DAY: {
    target: 'materialTypeDay',
  },
  MATERIAL_TYPE_NIGHT: {
    target: 'materialTypeNight',
  },
  MEASURE_INSURANCE: {
    target: 'measureInsurance',
  },
  MEASUREMENTS: {
    target: 'measurements.idle',
  },
  MOUNTING_SURFACE: {
    target: 'mountingSurface',
  },
  PLEAT_TYPE: {
    target: 'pleatType',
  },
  PLEAT_FINISH: {
    target: 'pleatFinish',
  },
  POWER_SUPPLY: {
    target: 'powerSupply',
  },
  RAIL_COLOUR: {
    target: 'railColour',
  },
  REMOTE_CONTROL: {
    target: 'remoteControl',
  },
  ROLL_DIRECTION: {
    target: 'rollDirection',
  },
  ROOM_NAME: {
    target: 'roomName',
  },
  SHIPPING: {
    target: 'shipping',
  },
  SLAT_SIZE: {
    target: 'slatSize',
  },
  STACK_SIDE: {
    target: 'stackSide',
  },
  TILT_CONTROL: {
    target: 'tiltControl',
  },
  TILT_POSITION: {
    target: 'tiltPosition',
  },
  TRACK: {
    target: 'track',
  },
  TRACK_REQUIRE: {
    target: 'trackRequire',
  },
  TRACK_COLOUR: {
    target: 'trackColour',
  },
  PULL_ROD: {
    target: 'pullRod',
  },
  PULLROD_COLOUR: {
    target: 'pullRodColour',
  },
  VENETIAN_VALANCE: {
    target: 'venetianValance',
  },
  WIFI_HUB: {
    target: 'wifiHub',
  },
  BLADE_SIZE: {
    target: 'bladeSize',
  },
  FRAME_STYLE: {
    target: 'frameStyle',
  },
  NUMBER_OF_PANELS: {
    target: 'numberOfPanels',
  },
  PANEL_CONFIGURATION: {
    target: 'panelConfiguration',
  },
  DYNAMIC_PRICE: {
    target: 'dynamicPrice',
  },
  OPERATION: {
    target: 'operation',
  },
  SMART_RELEASE: {
    target: 'smartRelease',
  },
  FASCIA: {
    target: 'fascia',
  },
  TOTAL_PRICE: {
    target: 'totalPrice',
  },
  SMART_RELEASE_PRICE: {
    target: 'smartReleasePrice',
  },
  LIGHT_GUARD_PRICE: {
    target: 'lightGuardPrice',
  },
  VENETIAN_VALANCE_PRICE: {
    target: 'venetianValancePrice',
  },
  TRACK_PRICE: {
    target: 'trackPrice',
  },
  FASCIA_PRICE: {
    target: 'fasciaPrice',
  },
  EXTENSION_POLE_PRICE: {
    target: 'extensionPolePrice',
  },
  MEASURE_INSURANCE_PRICE: {
    target: 'measureInsurancePrice',
  },
  STAINLESS_STEEL_CHAIN: {
    target: 'stainlessSteelChain',
  },
  STAINLESS_STEEL_CHAIN_PRICE: {
    target: 'stainlessSteelChainPrice',
  },
  HONEYCOMB_VERTICAL_CENTRE_OPENING_SURCHARGE_PRICE: {
    target: 'honeycombVerticalCentreOpeningSurchargePrice',
  },
  HONEYCOMB_VERTICAL_CENTRE_OPENING_SURCHARGE: {
    target: 'honeycombVerticalCentreOpeningSurcharge',
  },
  CEILING_MOUNT_PLEATED_CURTAIN_RAIL: {
    target: 'ceilingMountPleatedCurtainRail',
  },
  FACE_MOUNT_PLEATED_CURTAIN_RAIL: {
    target: 'faceMountPleatedCurtainRail',
  },
  CEILING_MOUNT_WAVE_FOLD_CURTAIN_RAIL: {
    target: 'ceilingMountWaveFoldCurtainRail',
  },
  FACE_MOUNT_WAVE_FOLD_CURTAIN_RAIL: {
    target: 'faceMountWaveFoldCurtainRail',
  },
  CEILING_MOUNT_PLEATED_CURTAIN_DOUBLE_RAIL: {
    target: 'ceilingMountPleatedCurtainDoubleRail',
  },
  FACE_MOUNT_PLEATED_CURTAIN_DOUBLE_RAIL: {
    target: 'faceMountPleatedCurtainDoubleRail',
  },
  CEILING_MOUNT_WAVE_FOLD_CURTAIN_DOUBLE_RAIL: {
    target: 'ceilingMountWaveFoldCurtainDoubleRail',
  },
  FACE_MOUNT_WAVE_FOLD_CURTAIN_DOUBLE_RAIL: {
    target: 'faceMountWaveFoldCurtainDoubleRail',
  },
};

const actionEvents = {
  UPDATE_CUSTOM: {
    actions: ['updateCustom', 'updateUrl'],
  },
  UPDATE_CART: {
    actions: ['getCartSuccess'],
  },
  GET_PRODUCT_WITH_MEASUREMENTS: {
    target: 'measurements.loading',
    cond: 'hasMeasurements',
  },
};

export const events = {
  ...stateTransitionEvents,
  ...actionEvents,
};
